import { topics } from '@/mocks/topics';
import SectionHeading from '@/components/feature/SectionHeading';
import TopicCard from '@/components/feature/TopicCard';

export default function TopicSection() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="TOPIC BOARD"
        title="瓜圈速报话题榜"
        description="按主题把散落的热点串成线，想系统追一条线的时候，从话题入口进去更快。"
        actionLabel="进入话题榜"
        actionTo="/topics"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {topics.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}